
import {
    Spacer,
    Text
} from '@components/1-atoms';
import ListItem, { ListSectionHeader } from '@components/2-molecules/ListItem';
import setTheme from '@lib/theme';
import React, { FC } from 'react';
import { View } from 'react-native';

import { PageProps } from '@lib/constants';

type Props = PageProps;

const theme = setTheme('light');

const DashboardMenu: FC<Props> = ({ navigation, onDone, ...props }) => {

    return (
        <View>
            <ListSectionHeader>{'CONTACTS'}</ListSectionHeader>
            <ListItem
                /* right={ <Forward />} */
                hideLine
                sub={<Text small color={"#808080"}>{"Add an entity that you do business with."}</Text>}
                onPress={() => navigation?.navigate('ContactCreate', { ...props, onDone })}
            >
                <Text>Create a contact reference</Text>
            </ListItem>
            <Spacer h={0.3} />


            <ListSectionHeader >{'DOCUMENTS'}</ListSectionHeader>
            <ListItem
                /* right={ <Forward />} */
                hideLine
                sub={<Text small color={"#808080"}>{"Conveniently send quote to your customers."}</Text>}
                onPress={() => navigation?.navigate('EstimateCreate', { ...props, onDone })}
            >
                <Text>Create an estimate for a customer</Text>
            </ListItem>
            <Spacer h={0.3} />


            {/* <Title color='#808080' xsmall bold>{'BANKING'}</Title>
            <ListItem
                sub={<Text small color={"#808080"}>{"Track all your bank transactions."}</Text>}
            >
                <Text>Reconcile a bank account</Text>
            </ListItem>
            <Spacer h={0.3} /> */}

            <ListSectionHeader>{'CHART OF ACCOUNTS'}</ListSectionHeader>
            <ListItem
                /* right={ <Forward />} */
                hideLine
                sub={<Text small color={"#808080"}>{"Define your chart of accounts, and categorize every single transaction."}</Text>}
                onPress={() => navigation?.navigate('AccountCreate', { ...props, onDone })}
            >
                <Text>Create an account</Text>
            </ListItem>
            <Spacer h={0.3} />


            <ListSectionHeader>{'PRODUCTS AND SERVICES'}</ListSectionHeader>
            <ListItem
                /* right={ <Forward />} */
                sub={<Text small color={"#808080"}>{"Invoiced items are those that you buy or sell as part of your operations."}</Text>}
                onPress={() => navigation?.navigate('NonInventoryProductServiceCreate', { ...props, onDone })}
            >
                <Text>Create a product or service</Text>
            </ListItem>
            <Spacer h={0.3} />

            <ListItem
                /* right={ <Forward />} */
                sub={<Text small color={"#808080"}>{"Invoiced and stock-monitored items are those that you buy or sell as part of your operations."}</Text>}
                onPress={() => navigation?.navigate('InventoryProductCreate', { ...props, onDone })}
            >
                <Text>Create an inventory product / good</Text>
            </ListItem>
            <Spacer h={0.3} />

        </View>
    );
};

export default DashboardMenu;